
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform_status",
      function () {
        return require("private-next-pages/platform_status/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform_status"])
      });
    }
  